import common from '@/common'

export default function gtag(...args: any){
    window.dataLayer = window.dataLayer || [];
    const {projectCode} = common
    if(projectCode === 'product' || projectCode === 'tm') {
        window.dataLayer.push(arguments) 
    } 
};